import { apiClient } from './index';

// 연자 검색 인터페이스
export interface LecturerSearchItem {
  id: number;
  name: string;
  department: string;
  image_url?: string;
  tags: string[];
}

export interface LecturerSearchResponse {
  code: number;
  status: string;
  message: string;
  data: {
    content: LecturerSearchItem[];
    pageable: {
      pageNumber: number;
      pageSize: number;
      sort: {
        empty: boolean;
        sorted: boolean;
        unsorted: boolean;
      };
      offset: number;
      paged: boolean;
      unpaged: boolean;
    };
    totalElements: number;
    totalPages: number;
    last: boolean;
    size: number;
    number: number;
    sort: {
      empty: boolean;
      sorted: boolean;
      unsorted: boolean;
    };
    numberOfElements: number;
    first: boolean;
    empty: boolean;
  };
}

// 연자 목록 검색
export const searchLecturers = async (keyword: string): Promise<LecturerSearchItem[]> => {
  try {
    /// console.log(`연자 검색 시작 키워드: ${keyword}`);
    
    const response = await apiClient.get<LecturerSearchResponse>(`/api/search/mentors`, {
      params: { keyword }
    });
    
    /// console.log('연자 검색 API 응답:', {response});
    
    if (response.data.code === 200) {
      const content = response.data.data.content || [];
      // API 응답의 department 필드를 그대로 사용 (매핑 로직 제거)
      return content;
    } else {
      /// console.warn('[lecturerSearchApi] 연자 검색 실패:', response.data.message);
      return [];
    }
  } catch (error) {
    /// console.error('[lecturerSearchApi] 연자 검색 중 오류:', error);
    return [];
  }
};
